import React from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Footer } from '../../components/Common/Footer';
import { CTA } from '../../components/Common/CTA';

const NotFoundContainer = styled.main`
  min-height: calc(100vh - 256px);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;

  .logo-eskala {
    max-height: 32px;
  }
  .promo {
    max-width: 200px;
  }
`;

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <NotFoundContainer>
        <img src={ process.env.REACT_APP_APP_URL + 'images/eskala.svg'} alt='Logo Eskala' className='logo-eskala' />
        <img src={ process.env.REACT_APP_APP_URL + 'images/logo.png'} alt='Logo Eskala Dia das Crianças - Diversão Surpresa' className='promo' />
        <Typography variant='h4' component='h1' className='bold-text black--text'>
          Página não encontrada
        </Typography>
        <CTA onClick={ () => navigate('/')}>Ir para início</CTA>
      </NotFoundContainer>
      <Footer />
    </>
  )
}
